export const facadeActionTypes = {
  BEING_EDITED: 'BEING_EDITED',
  SELECT_NUM: 'SELECT_NUM',
  INITIATE_FACADE: 'INITIATE_FACADE',
  UPDATE_PANELS: 'UPDATE_PANELS',
  EDIT_FACADE: 'EDIT_FACADE', //used to repopulate facade from 'edited' project
  RESET_FACADE: 'RESET_FACADE', //uset to revert state to initial state
  SET_POSITION: 'SET_POSITION',
};
